import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { api } from "../redux/api";
import { createSocketClient, getSocketAuthToken } from "../utils/socketAuth";

/**
 * useJobLiveUpdates
 * Subscribes to job/leg socket events and invalidates RTK Query caches.
 */
export const useJobLiveUpdates = ({ jobId, enabled }) => {
  const dispatch = useDispatch();
  const socketRef = useRef(null);

  useEffect(() => {
    if (!enabled || !jobId) return;

    const authToken = getSocketAuthToken();
    if (!authToken) return;

    const socket = createSocketClient({ auth: { token: authToken } });

    socketRef.current = socket;

    const invalidateForJob = (payload = {}) => {
      const payloadJobId = payload.jobId || jobId;
      if (!payloadJobId || payloadJobId !== jobId) return;

      const tags = [
        { type: "Jobs", id: payloadJobId },
        { type: "Legs", id: "LIST" },
      ];

      if (payload.legId) {
        tags.push({ type: "Legs", id: payload.legId });
      }

      dispatch(api.util.invalidateTags(tags));
    };

    socket.on("connect", () => {
      socket.emit("job:subscribe", { jobId });
    });

    socket.on("job:updated", invalidateForJob);
    socket.on("leg:updated", invalidateForJob);

    return () => {
      if (socket) {
        socket.emit("job:unsubscribe", { jobId });
        socket.off("job:updated", invalidateForJob);
        socket.off("leg:updated", invalidateForJob);
        socket.close();
      }
    };
  }, [dispatch, enabled, jobId]);
};

export default useJobLiveUpdates;
